import React from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Button } from '@mui/material';

interface StepperLeftButtonProps {
  activeStep: number;
  onClick: () => void;
  classes: any;
}

const StepperLeftButton: React.FC<StepperLeftButtonProps> = ({ activeStep, onClick, classes }) =>
  activeStep !== 0 ? (
    <Button disableElevation className={classes.buttonSecondaryLight} onClick={onClick}>
      <ChevronLeftIcon />
    </Button>
  ) : null;

export default StepperLeftButton;
